import { createAsyncThunk } from '@reduxjs/toolkit';
import { DEFAULT_PAGE_SIZE, MESSAGE_LOADING_DIRECTIONS } from '../../../clients/gccApiClient/gccApiClient';

import { channelMessagesUpsert } from '../messagesSlice';

const fetchMessages = createAsyncThunk(
  'messages/fetchMessages',
  async (
    {
      channelId,
      pageSize = DEFAULT_PAGE_SIZE,
      fromMessageIndex = undefined,
      toMessageIndex = undefined,
      direction = MESSAGE_LOADING_DIRECTIONS.BACKWARDS,
      singlePage = false,
      includeAnchorMessage = false,
      throwIfToMessageIndexNotFound = true,
    },
    { dispatch, _, extra: { gccApiClient } },
  ) => {
    const { messages, firstMessageLoaded } = await gccApiClient.getChannelMessages({
      channelId,
      pageSize,
      fromMessageIndex,
      toMessageIndex,
      direction,
      singlePage,
      includeAnchorMessage,
      throwIfToMessageIndexNotFound,
    });

    dispatch(
      channelMessagesUpsert({
        channelMessages: { [channelId]: messages },
        channelFirstMessageLoaded: { [channelId]: firstMessageLoaded },
      }),
    );
  },
);
export default fetchMessages;
